// Languages supported by the Gemini Live API, sent as `locale` to LiveKit.
// Labels show the English name and the native language name.
// Shared by the Settings popover (mobile) and the desktop toolbar language menu.
export const CALL_LANGUAGES = [
  { code: 'en-US', label: 'English (US)' },
  { code: 'en-GB', label: 'English (UK)' },
  { code: 'en-AU', label: 'English (Australia)' },
  { code: 'en-IN', label: 'English (India)' },
  { code: 'ar-XA', label: 'Arabic (العربية)' },
  { code: 'bn-IN', label: 'Bengali (বাংলা)' },
  { code: 'cmn-CN', label: 'Chinese, Mandarin (普通话)' },
  { code: 'nl-NL', label: 'Dutch (Nederlands)' },
  { code: 'fr-FR', label: 'French (Français)' },
  { code: 'fr-CA', label: 'French, Canada (Français canadien)' },
  { code: 'de-DE', label: 'German (Deutsch)' },
  { code: 'gu-IN', label: 'Gujarati (ગુજરાતી)' },
  { code: 'hi-IN', label: 'Hindi (हिन्दी)' },
  { code: 'id-ID', label: 'Indonesian (Bahasa Indonesia)' },
  { code: 'it-IT', label: 'Italian (Italiano)' },
  { code: 'ja-JP', label: 'Japanese (日本語)' },
  { code: 'kn-IN', label: 'Kannada (ಕನ್ನಡ)' },
  { code: 'ko-KR', label: 'Korean (한국어)' },
  { code: 'ml-IN', label: 'Malayalam (മലയാളം)' },
  { code: 'mr-IN', label: 'Marathi (मराठी)' },
  { code: 'pl-PL', label: 'Polish (Polski)' },
  { code: 'pt-BR', label: 'Portuguese, Brazil (Português)' },
  { code: 'ru-RU', label: 'Russian (Русский)' },
  { code: 'es-ES', label: 'Spanish (Español)' },
  { code: 'es-US', label: 'Spanish, US (Español)' },
  { code: 'ta-IN', label: 'Tamil (தமிழ்)' },
  { code: 'te-IN', label: 'Telugu (తెలుగు)' },
  { code: 'th-TH', label: 'Thai (ไทย)' },
  { code: 'tr-TR', label: 'Turkish (Türkçe)' },
  { code: 'vi-VN', label: 'Vietnamese (Tiếng Việt)' },
];
